// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"ReviewWritePhoto_image-wrapper__1TlIN","image":"ReviewWritePhoto_image__1C4Gr","xmark-wrapper":"ReviewWritePhoto_xmark-wrapper__Gt2Az"};